define('OutSystems/ClientRuntime/NativeHelper',["require", "exports", "./Flow", "./Logger", "./modules/Common/BrowserUtils"], function (require, exports, Flow, Logger, BrowserUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.addNativeEventListener = exports.exitApp = exports.ensureNativeReady = exports.whenDeviceReady = exports.isIOS = exports.isAndroid = exports.isRunningOnNative = void 0;
    var SupportedPlatforms = {
        Android: "Android",
        iOS: "iOS",
    };
    function trace(message) {
        Logger.trace("NativeHelper", message);
    }
    function isRunningOnNative() {
        var isNative = typeof navigator !== "undefined" && /OutSystemsApp/i.test(navigator.userAgent);
        var isInsideIframe = BrowserUtils_1.windowInsideIframe(typeof window !== "undefined" ? window : null);
        trace("Running on " + (isNative ? "native shell" : "browser") + (isInsideIframe ? " inside an iframe" : ""));
        return !isInsideIframe && isNative;
    }
    exports.isRunningOnNative = isRunningOnNative;
    function isAndroid() {
        return isRunningOnPlatform(SupportedPlatforms.Android);
    }
    exports.isAndroid = isAndroid;
    function isIOS() {
        return isRunningOnPlatform(SupportedPlatforms.iOS);
    }
    exports.isIOS = isIOS;
    function isRunningOnPlatform(platform) {
        return isRunningOnNative() && window.device.platform === platform;
    }
    exports.whenDeviceReady = Flow.promise(function (resolve, reject) {
        if (!addEventListener("deviceready", function () { return resolve(); })) {
            resolve();
        }
    });
    var nativeReadyPromise = null;
    function ensureNativeReady() {
        if (!nativeReadyPromise) {
            nativeReadyPromise = Flow.promise(function (resolve, reject) {
                trace("Waiting for 'deviceready' event");
                if (isRunningOnNative()) {
                    if (window.cordova === undefined) {
                        reject("Running on native but cordova wasn't loaded");
                    }
                    else {
                        resolve(exports.whenDeviceReady);
                    }
                }
                else {
                    trace("'deviceready' event wait ignored");
                    resolve();
                }
            });
        }
        return nativeReadyPromise;
    }
    exports.ensureNativeReady = ensureNativeReady;
    function exitApp() {
        if (isAndroid()) {
            navigator.app.exitApp();
            return true;
        }
        else {
            return false;
        }
    }
    exports.exitApp = exitApp;
    function addNativeEventListener(event, listener) {
        ensureNativeReady().then(function () { return addEventListener(event, listener); });
    }
    exports.addNativeEventListener = addNativeEventListener;
    function addEventListener(event, listener) {
        if (typeof document !== "undefined" && document.addEventListener) {
            document.addEventListener(event, listener);
            return true;
        }
        return false;
    }
});
//# sourceMappingURL=NativeHelper.js.map;
